import { createReducer } from '../../lib/Utils'
import {
  GET_SEAT_BRAND_RETAILERS_BULK_GET,
  GET_SEAT_BRAND_RETAILERS_BULK_GET_FULFILLED,
  GET_SEAT_BRAND_RETAILERS_BULK_GET_REJECTED,
  SET_SEAT_TABLE_PARAMETERS,
  GET_GROUP_RETAILERS_FULFILLED,
  GET_GROUP_RETAILERS_REJECTED,
  GET_BRAND_RETAILERS_FULFILLED,
  GET_BRAND_RETAILERS_REJECTED,
  GET_FACEBOOK_PAGES_FULFILLED,
} from './actions'

/**
 * @typedef RetailersStore
 * @property {object} getSeatBrandRetailersBulkGetResponse
 * @property {object} seatTableParameters
 * @property {array} seatTableRetailers
 * @property {number} seatTableRetailersTotal
 * @property {number} seatTableRetailersFilteredTotal
 */
/**
 * @type RetailersStore
 */
const initialState = {
  retailersById: {},
}

export default createReducer(initialState, {
  [GET_SEAT_BRAND_RETAILERS_BULK_GET]: (state) => {
    const newState = {
      ...state,
      getSeatBrandRetailersBulkGetResponse: {
        success: false,
        error: false,
        loading: true,
      },
    }
    return newState
  },
  [GET_SEAT_BRAND_RETAILERS_BULK_GET_FULFILLED]: (state, action) => {
    const newState = { ...state, ...action.payload }
    return newState
  },
  [GET_SEAT_BRAND_RETAILERS_BULK_GET_REJECTED]: (state, action) => {
    const newState = { ...state, ...action.payload }
    return newState
  },
  [SET_SEAT_TABLE_PARAMETERS]: (state, action) => {
    const newState = {
      ...state,
      seatTableParameters: { ...state.seatTableParameters, ...action.payload },
    }
    return newState
  },
  [GET_GROUP_RETAILERS_FULFILLED]: (state, action) => {
    const newState = { ...state, ...action.payload }
    return newState
  },
  [GET_GROUP_RETAILERS_REJECTED]: (state, action) => {
    const newState = { ...state, ...action.payload }
    return newState
  },
  [GET_BRAND_RETAILERS_FULFILLED]: (state, action) => {
    const { retailers } = action.payload
    const newState = { ...state, retailers }
    return newState
  },
  [GET_BRAND_RETAILERS_REJECTED]: (state, action) => {
    const newState = { ...state, ...action.payload }
    return newState
  },
  [GET_FACEBOOK_PAGES_FULFILLED]: (state, action) => {
    const newState = { ...state, facebookPages: action.payload }
    return newState
  },
})
